module.exports = "img/user-onboarding/PersonalMessaging.12f2bc3.png";